<!-- Vertical layout -->
<app-vertical></app-vertical>
@if(accessbot){
    <app-chatbot></app-chatbot>
}
<app-downloadwindow #downloadfiles id="downloadfiles-window" class="d-none" (closeDownloader)="closeDownloadWindow($event)"></app-downloadwindow>